var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoverageDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_367_3004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.57554 10.7221L1.47168 13.2315V3.19377C1.47168 3.02738 1.53778 2.86781 1.65543 2.75016C1.77308 2.6325 1.93265 2.56641 2.09904 2.56641H12.1368C12.3032 2.56641 12.4628 2.6325 12.5804 2.75016C12.6981 2.86781 12.7642 3.02738 12.7642 3.19377V10.0947C12.7642 10.2611 12.6981 10.4207 12.5804 10.5383C12.4628 10.656 12.3032 10.7221 12.1368 10.7221H4.57554Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.23633 10.7236V13.8604C5.23633 14.0267 5.30242 14.1863 5.42008 14.304C5.53773 14.4216 5.6973 14.4877 5.86369 14.4877H13.4249L16.5288 16.9972V6.95939C16.5288 6.79301 16.4627 6.63343 16.3451 6.51578C16.2274 6.39813 16.0678 6.33203 15.9014 6.33203H12.7646",
    stroke: "#1A1A1A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_3004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverageDetail);
export default __webpack_public_path__ + "static/media/coverage-detail.d307af2f.svg";
export { ForwardRef as ReactComponent };